import { queryStringify, STORAGE_EVENT } from '@utils'
import { createRequestHelper, createStorageProvider } from '@utils/swr'
import { type CartCalculateErrorResponse } from '../types/apiErrorResponse'
import { type ECommerceCartCalculateRequest } from '../types/apiRequest'
import { type ECommerceCartCalculateResponse } from '../types/apiResponse'
import { type ECommerceV2Apis } from '../types/apis'

/**
 * 將 checkoutFields 存到 localStorage 中，加速初次頁面渲染
 */
const provider = createStorageProvider('ec-cart-calculate', STORAGE_EVENT.sessionStorage)

const { useRequest } = createRequestHelper<ECommerceV2Apis['post']['cartCalculate'], ECommerceCartCalculateResponse, ECommerceCartCalculateRequest | null, CartCalculateErrorResponse>({
  client: 'eCommerceV2',
  key: (params) => {
    if (!params) return null
    const { order_items, project_code, country_code, billing_country } = params
    if (!project_code || !country_code || !order_items || !billing_country) {
      return null
    }
    if (order_items.some(order_item => !order_item.sku)) {
      console.warn('[useApiECommerceCartCalculate] sku is required in order_items')
      return null
    }
    // 這裡的 querystring 是用來做 cache key 的實際送值是在 fetcher 裡面
    return `/${country_code}/cart/calculate?${queryStringify(params)}`
  },
  fetcher: client => (url, params) => client.post(url, params, {
    headers: {
      'Accept-Language': params?.language,
    },
  }),
  provider,
})

export const useApiECommerceCartCalculate = useRequest
